import{a as t}from"./chunk-RAAYCPUM.js";function a(...e){return t(n,e)}var n=e=>e.at(-1);export{a};
